import { lazy } from 'react';

const User = lazy(() => import('features/user/UserScreen'));
const UserFormScreen = lazy(() => import('features/user/components/UserFormScreen'));
const Master = lazy(() => import('features/master/MasterScreen'));
const Mapping = lazy(() => import('features/mapping/MappingScreen'));
const MasterForm = lazy(() => import('features/master/components/MasterFormScreen'));
const IndustrySales = lazy(() => import('features/industrySales/IndustrySalesScreen'));
const SubmissionSummary = lazy(() => import('features/industrySales/SubmissionSummaryScreen'));
const Dashboard = lazy(() => import('features/dashboard/Dashboard'));
const MySales = lazy(() => import('features/mySales/MySalesScreen'));
const MySalesExcelScreen = lazy(() => import('features/mySales/MySalesExcelScreen'));
const SalesCreateChangeLog = lazy(() => import('features/notification/SalesCreateChangeLog'));
const SalesUpdatedChangeLog = lazy(() => import('features/notification/SalesUpdatedChangeLog'));
const MasterCreateChangeLog = lazy(() => import('features/notification/MasterCreateChangeLog'));
const MasterUpdatedChangeLog = lazy(() => import('features/notification/MasterUpdatedChangeLog'));
const MasterDeleteChangeLog = lazy(() => import('features/notification/MasterDeleteChangeLog'));
const MasterHistoryLog = lazy(() => import('features/master/components/MasterHistory'));
const MappingHistoryLog = lazy(() => import('features/mapping/components/MappingHistory'));
const MarketList = lazy(() => import('features/mapping/MarketListScreen'));
const MySalesHistoryLog = lazy(() => import('features/mySales/components/MySalesHistory'));
const MyProfile = lazy(() => import('hoc/layout/component/MyProfile'));
const ChangePassword = lazy(() => import('hoc/layout/component/ChangePassword'));
const AccessDenied = lazy(() => import('shared/components/AMBGAccessDenied/AMBGAccessDenied'));
const NewsRoomScreen = lazy(() => import('features/newsRoom/NewsRoomScreen'));
const NewsFormScreen = lazy(() => import('features/newsRoom/components/NewsFormScreen'));
const NewsInteractionsView = lazy(() => import('features/newsRoom/components/NewsInteractionsView'));
const NewsDetailViewScreen = lazy(() => import('features/dashboard/components/NewsViewDetail'));
const VotingScreen = lazy(() => import('features/voting/Voting'));
const VoteForm = lazy(() => import('features/voting/components/VoteForm'));
const VoteResult = lazy(() => import('features/voting/components/VoteResult'));

export {
	AccessDenied,
	ChangePassword,
	Dashboard,
	IndustrySales,
	Master,
	Mapping,
	MasterCreateChangeLog,
	MasterDeleteChangeLog,
	MasterForm,
	MasterHistoryLog,
	MappingHistoryLog,
	MarketList,
	MasterUpdatedChangeLog,
	MyProfile,
	MySales,
	MySalesExcelScreen,
	MySalesHistoryLog,
	NewsDetailViewScreen,
	NewsFormScreen,
	NewsInteractionsView,
	NewsRoomScreen,
	SalesCreateChangeLog,
	SalesUpdatedChangeLog,
	SubmissionSummary,
	User,
	UserFormScreen,
	VoteForm,
	VotingScreen,
	VoteResult
};
